'use client';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomImage from '@components/CustomImage';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import cn from './style.module.scss';
export default function LsqSodicDarna(props: MarketingPageComponentProps) {
  const darnaSection = props?.locale?.section?.find(
    (section: any) => section.type === 'darna' && section.enabled
  );
  if (!darnaSection) return null;
  const sliderItems = darnaSection?.lsqSodicDarnaSlider ?? [];
  const appData = darnaSection?.lsqSodicDarnaAppData ?? {};
  const appIcons = darnaSection?.lsqSodicDarnaAppIcons ?? [];
  const sliderOptions = {
    type: 'loop',
    rewind: true,
    pagination: true,
    arrows: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
  };
  return (
    <Stack component="section" className={cn.sodicDarnaWrapper}>
      <Box className={cn.sodicDarnaInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicDarnaBlock}>
            <Box className={cn.sodicDarnaContent}>
              <Box className={cn.darnaContentInner}>
                <Box className={cn.sodicDarnaData}>
                  <ParallaxText
                    variant="h3"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(appData.appHeading)}
                  </ParallaxText>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(appData.appContent)}
                  </ParallaxText>
                </Box>
                <Box className={cn.sodicDarnaIcons}>
                  <List className={cn.sodicDarnaList}>
                    {appIcons.map((item: any, index: number) => (
                      <ListItem
                        key={index}
                        className={cn.sodicDarnaItem}
                        {...mergeAos(fadeUpAosProps, getAosDelay(index * 100))}
                      >
                        <a
                          className={cn.sodicDarnaLink}
                          href={item?.hrf}
                          target="_blank" rel="noopener noreferrer"
                        >
                          <CustomImage
                            src={item?.url}
                            alt={item?.alt}
                            width={1920}
                            height={800}
                          />
                        </a>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
